import React, { useEffect, useState } from 'react';
import classes from './ProductCard.module.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import Container from '../../components/UI/Container/Container';
import { Col, message, Skeleton, Space, Typography, Grid, Tabs } from 'antd';
import { getProductsDenominations } from '../../http/products';
import { getUser } from '../../redux/selectors';
import { connect, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import apex from '../../assets/images/apex-legends-icon-16.jpg';
import Headline from '../../components/UI/Headline/Headline';
import { addToCart } from '../../http/cart';
import BackLink from '../../components/BackLink/BackLink';
import Activation from './Activation';
import Info from './Info';
import './ProductCard.scss';
import { addToBanner, openBanner } from '../../http/app';

const ProductCard = ({
  activity,
  products,
  activeCategory,
  categories,
  bannerOpen,
  cart
}) => {
  const [denominations, setDenominations] = useState([]);
  const [selectedDenomination, setSelectedDenomination] = useState();
  const [quantity, setQuantity] = useState(1);

  const location = useLocation();
  const navigate = useNavigate();
  const breakpoints = Grid.useBreakpoint();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [messageApi, contextHolder] = message.useMessage();

  const searchParams = new URLSearchParams(location.search);
  const productIdParam = searchParams.get('product');
  const currentProduct = products?.find((c) => c.t_product_id == productIdParam);
  const productId = currentProduct.id

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getProductsDenominations(productId)).then(setDenominations);
  }, []);

  const [limitError, setLimitError] = useState('');
  const totalCartAmount = cart.reduce((acc, item) => acc + item.quantity, 0);

  const willExceedTotalLimit = totalCartAmount + quantity > 5;

  const isAddDisabled = willExceedTotalLimit;
  const showLimitMessage = willExceedTotalLimit;


  const add = async () => {
    if (willExceedTotalLimit) {
      setLimitError(
        t('cart.limit.total')
      );
      return;
    }
    try {
      await dispatch(addToCart(currentProduct, selectedDenomination, quantity));

      if (!bannerOpen) {
        dispatch(
          openBanner({
            name: currentProduct.name,
            denomination: selectedDenomination.name,
            price: selectedDenomination.price
          })
        );
      } else {
        dispatch(
          addToBanner({
            name: currentProduct.name,
            denomination: selectedDenomination.name,
            price: selectedDenomination.price
          })
        );
      }

      messageApi.success({
        type: 'success',
        content: t('cart.success.added')
      });
    } catch (error) {
      messageApi.error({
        type: 'error',
        content: error.message ?? 'Failed to add to cart'
      });
    }
  };

  const navigateToCategory = (category) => {
    navigate('/');
    dispatch({ type: 'Products/SET_ACTIVE_CATEGORY', payload: category });
  };

  const tabsItems = [
    {
      key: 'info',
      label: t('pages.productCard.info'),
      children: (
        <Info
          product={currentProduct}
          activity={activity}
          denominations={denominations}
          selectedDenomination={selectedDenomination}
          setSelectedDenomination={setSelectedDenomination}
          quantity={quantity}
          setQuantity={setQuantity}
          onAdd={add}
          isAddDisabled={isAddDisabled}
          showLimitMessage={showLimitMessage}
        />
      )
    },
    {
      key: 'activation',
      label: t('pages.productCard.activation'),
      children: <Activation product={currentProduct} activity={activity} />
    }
  ];

  return (
    <div style={{ width: '100%' }}>
      <Container style={{ marginTop: 190, marginBottom: 150 }}>
        {contextHolder}
        <BackLink />
        <div
          style={{ display: 'flex', gap: 8, padding: '20px 0' }}
          id='breadcrumbs'
        >
          <Typography
            style={{
              cursor: 'pointer',
              textDecoration: 'underline',
              fontWeight: 400
            }}
            onClick={() => navigateToCategory(categories[0])}
          >
            {t('etc.main')}
          </Typography>
          <Typography>{'>'}</Typography>
          <Typography
            style={{
              cursor: 'pointer',
              textDecoration: 'underline',
              fontWeight: 400
            }}
            onClick={() => navigate('/')}
          >
            {i18n.language === 'en'
              ? activeCategory?.name
              : activeCategory?.name_lv}
          </Typography>
          <Typography>{'>'}</Typography>
          <Typography style={{ fontWeight: 400 }}>
            {i18n.language === 'en'
              ? currentProduct?.name
              : currentProduct?.name_lv}
          </Typography>
        </div>
        <Skeleton title={false} paragraph={{ rows: 1 }} loading={activity} active>
          <Headline>
            {i18n.language === 'en'
              ? currentProduct?.name
              : currentProduct?.name_lv}
          </Headline>
        </Skeleton>
        <div className={classes.container}>
          <div
            style={{
              display:
                !breakpoints.lg &&
                  !breakpoints.md &&
                  !breakpoints.xl &&
                  !breakpoints.xxl
                  ? 'none'
                  : 'block'
            }}
          >
            <div className={`${classes.img}`}>
              <img src={currentProduct?.imgUrl || apex} alt='' />
            </div>
            <Skeleton
              title={false}
              paragraph={{ rows: 1 }}
              loading={activity}
              active
            >
              <Space size={10} style={{ marginTop: 20 }}>
                <Typography style={{ fontSize: 24, fontWeight: 400 }}>
                  {t('pages.productCard.region')}:
                </Typography>
                <Typography style={{ fontSize: 24, fontWeight: 400 }}>
                  {i18n.language === 'en'
                    ? currentProduct?.region || t('etc.noData')
                    : currentProduct?.region || t('etc.noData')}
                </Typography>
              </Space>
            </Skeleton>
          </div>

          <Col xs={24} sm={24} md={16} lg={16}>
            <Tabs
              id='product-tabs'
              tabBarStyle={{ color: 'black' }}
              type='card'
              defaultActiveKey='info'
              items={tabsItems}
            />
          </Col>
        </div>
      </Container>
      <div style={{ height: '170px', backgroundColor: '#584271' }} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  userId: getUser(state).userId,
  products: state.games.products,
  activeCategory: state.games.activeCategory,
  categories: state.games.categories,
  activity: state.app.activity,
  bannerOpen: state.app.banner.instance !== null,
  cart: state.games.cart
});

export default connect(mapStateToProps)(ProductCard);
